import { useState, useEffect, useCallback } from "react";
import { createPortal } from "react-dom";
import { useSetRecoilState } from "recoil";

import { Modal } from "../../Components/Modal";
import { AllstarModalState, ClipFullModalState } from "MVVM/State/modals";
import { ModalType } from "MVVM/@types";
import history from "../../../history";

export const usePortal = (content: JSX.Element, domNode: string = "root") => {
  const [portalOpen, setPortalOpen] = useState<boolean>(false);
  const setAllstarModalState = useSetRecoilState(AllstarModalState); // DO NOT CHANGE, YOU WILL CAUSE INFINITE RENDERS

  const closePortal = useCallback(() => {
    setPortalOpen(false);

    setAllstarModalState((prev) => ({
      ...prev,
      isOpen: ModalType.None,
    }));
  }, [setAllstarModalState]);

  useEffect(() => {
    if (!portalOpen) return;

    const unlisten = history.listen(() => {
      closePortal();
    });

    return () => {
      unlisten();
    };
  }, [portalOpen, closePortal]);

  const Portal = createPortal(
    <Modal isModalOpen={true} setModalOpen={closePortal}>
      {content}
    </Modal>,
    document.getElementById(domNode),
  );

  return { portalOpen, setPortalOpen, Portal };
};
